import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/fhq-ip-whitelist-record';
import { ResultState } from '@rootCommon/types/common';
import { IpWhitelistRecord } from '@rootCommon/types/fhq';

type Action = ActionType<typeof actions>;
export type IpWhitelistRecordsState = ResultState<IpWhitelistRecord[] | null>;

const initState: IpWhitelistRecordsState = {
  data: null,
  loading: false,
  error: null,
};

export const fhqIpWhitelistRecordsReducer = (state = initState, action: Action): IpWhitelistRecordsState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchIpWhitelistRecords.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchIpWhitelistRecords.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchIpWhitelistRecords.failure):
      return { ...state, loading: false, error: action.payload };

      // change
    case getType(actions.changeIpWhitelistRecord.request):
      return { ...state, loading: true, error: null };
    case getType(actions.changeIpWhitelistRecord.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.changeIpWhitelistRecord.failure):
      return { ...state, loading: false, error: action.payload };

    case getType(actions.setIpWhitelistRecordsIsLoading):
      return { ...state, loading: true };

    default:
      return state;
  }
};

export default fhqIpWhitelistRecordsReducer;
